import React from "react";
import DocTable from "./containers/DocTable";
const Sign = (props) => {
  return (
    <div>
      <DocTable fetch="pending" key="pending" title="Enviados para firma" tab={props.tab}/>
    </div>
  );
};
export default Sign;



// WEBPACK FOOTER //
// ./src/components/Sign.js